import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import Cabinet from '@/components/landing/cabinet/cabinet'
import { RESUME } from '@/components/landing/cabinet/data'

const Home: FC = (): ReactNode => {
    return (
        <Layout hideFooter>
            <Seo />

            <h1 className='sr-only'>
                {RESUME.name}, {RESUME.role}
            </h1>

            {/* the fixed site header sits over the cabinet's top edge, so no data-hide here */}
            <section id='portfolio' className='relative h-svh w-full overflow-hidden'>
                <Cabinet />
            </section>
        </Layout>
    )
}

export default Home
